(function () {
  function norm(s) {
    return (s || "").toString().replace(/\s+/g, " ").trim();
  }

  function toTitleCase(s) {
    s = norm(s).toLowerCase();
    return s.replace(/\b\w/g, (m) => m.toUpperCase());
  }

  // Icon shows current gemstone as text like "GEMSTONE: TURQUOISE"
  function getGemstoneFromLabel() {
    const container = document.querySelector(".product__variants-swatches");
    if (!container) return "";
    const txt = container.innerText || "";
    const m = txt.match(/gemstone\s*:\s*([^\n\r]+)/i);
    return m && m[1] ? norm(m[1]) : "";
  }

  // Fallback if theme uses a dropdown for options
  function getGemstoneFromSelect() {
    const sel = document.querySelector('select[name="options[Gemstone]"]');
    return sel ? norm(sel.value) : "";
  }

  function getRingSize() {
    const sel = document.querySelector('select[name="options[Ring Size]"]');
    if (sel) return norm(sel.value);
    const container = document.querySelector(".product__variants-swatches");
    if (!container) return "";
    const txt = container.innerText || "";
    const m = txt.match(/ring\s*size\s*:\s*([^\n\r]+)/i);
    return m && m[1] ? norm(m[1]) : "";
  }

  function getPrimaryGemstoneData() {
    const el = document.getElementById("js-primary-gemstone");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "{}");
    } catch {
      return null;
    }
  }

  // Decide which gemstone name we're using:
  // 1) variant selection (rings)
  // 2) primary gemstone metafield (pendants/uniques)
  function getGemstoneName() {
    const variantGem = getGemstoneFromSelect() || getGemstoneFromLabel();
    if (variantGem) return variantGem;

    const primary = getPrimaryGemstoneData();
    return primary?.name ? norm(primary.name) : "";
  }

  function update() {
    const gemstoneRaw = getGemstoneName();
    const gemstone = gemstoneRaw ? toTitleCase(gemstoneRaw) : "";

    // -----------------------------
    // H1: R4813 – Turquoise (Option 2)
    // -----------------------------
const h1 = document.querySelector(".product__section-title h1");

// Only append gemstone if a gemstone variant selector exists
const hasGemstoneVariant =
  document.querySelector('select[name="options[Gemstone]"]') ||
  document.querySelector(".product__variants-swatches");

if (h1 && hasGemstoneVariant) {
  const base =
    h1.getAttribute("data-base-title") ||
    norm(h1.textContent);

  if (!h1.getAttribute("data-base-title")) {
    h1.setAttribute("data-base-title", base);
  }

  h1.textContent = gemstone ? `${base} – ${gemstone}` : base;
}

    // -----------------------------
    // Description: Stone line placeholder
    // -----------------------------
    document.querySelectorAll(".js-stone-name").forEach(el => {
      el.textContent = gemstone || "";
    });

    // -----------------------------
    // Description: Ring size placeholder
    // -----------------------------
    const ringSize = getRingSize();
    document.querySelectorAll(".js-ring-size").forEach(el => {
      el.textContent = ringSize || "";
    });

    // -----------------------------
    // Healing section placeholders
    // -----------------------------
    document.querySelectorAll(".js-heal-stone").forEach(el => {
      el.textContent = gemstone || "";
    });

    const healTargets = document.querySelectorAll(".js-heal-text");

    // If the product doesn't include the healing HTML placeholders, don't error.
    if (!healTargets.length) return;

    // Determine healing HTML using:
    // 1) list metaobjects (custom.gemstones)
    // 2) fallback to primary gemstone (custom.primary_gemstone)
    let healingHtml = "";

    // 1) Try list JSON (variant products)
    const listEl = document.getElementById("js-gemstones-json");
    if (listEl && gemstone) {
      try {
        const data = JSON.parse(listEl.textContent || "{}");
        const items = Array.isArray(data.items) ? data.items : [];
        const found = items.find(
          (g) => norm(g.name).toLowerCase() === norm(gemstone).toLowerCase()
        );
        if (found?.healing_html) healingHtml = found.healing_html;
      } catch {
        // ignore
      }
    }

    // 2) Fallback to primary gemstone JSON (non-variant products)
    if (!healingHtml) {
      const primary = getPrimaryGemstoneData();
      if (primary?.healing_html) healingHtml = primary.healing_html;
    }

    // Render rich text as HTML (metaobject rich text should be safe/trusted)
    healTargets.forEach(el => {
      el.innerHTML = healingHtml || "";
    });
  }

  function bind() {
    update();

    // Handle dropdown changes and other input changes
    document.addEventListener("change", (e) => {
      if (
        e.target.closest(".product__variants-swatches") ||
        e.target.matches('select[name^="options["]')
      ) {
        setTimeout(update, 0);
      }
    });

    // Handle swatch clicks
    document.addEventListener("click", (e) => {
      if (e.target.closest(".product__variants-swatches")) {
        setTimeout(update, 0);
      }
    });

    // Safety for Shopify section reloads
    document.addEventListener("shopify:section:load", () => {
      setTimeout(update, 0);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();
